import { getCurrentInstance } from 'vue'

export const useGlobalProperties = () => {
  const vm = getCurrentInstance()
  const globalProperties = vm?.appContext.config.globalProperties

  return { ...globalProperties }
}
